module.exports = __webpack_public_path__ + "static/media/calendar-circle.a62c927f.svg";